"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

type Callback = (asPath : string) => void;

export default function useRouteChange(callback : Callback) : null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const queryString = searchParams ? `?${searchParams}` : "";
    const asPath = `${pathname}${queryString}`;
    callback(asPath);
  }, [pathname, searchParams?.toString(), callback]);

  return null;
}
